import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SelfServiceService } from '../../../core/http/self-service.service';
import { SampleService } from '../../../core/http/sample.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent implements OnInit {

  isLoading = false;
  Errors = null;
  socs = null;
  mode = "view";
  selectedDr
  Success = null
  return;
  drs: any = []
  data: any = []

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public sample: SampleService, private self: SelfServiceService) { }

  ngOnInit(): void {

    this.self
    .getAppointments()
    .subscribe(
      (resSuccess) => {
        this.data = resSuccess
        console.log(this.data);

      },
      (resErr) => {
        this.Errors = resErr;
      }
    )

  }

  view(app) {

  }

}
